import { useEffect, useState } from "react";
import axios from "axios";
import { Star, Quote } from "lucide-react";
import { Reveal, MonoLabel } from "./shared";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Testimonials() {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/reviews`)
      .then(({ data }) => {
        if (!cancelled) setReviews(data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (reviews.length === 0) return null;

  return (
    <section data-testid="testimonials-section" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8 lg:px-14">
        <Reveal>
          <MonoLabel>Customer Reviews</MonoLabel>
          <h2 className="mt-4 font-display text-5xl uppercase leading-[0.9] tracking-wide sm:text-6xl lg:text-7xl">
            Word From <span className="text-gold">The Road</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {reviews.map((r, i) => (
            <Reveal
              key={r.id}
              delay={i * 0.07}
              className="h-full"
            >
              <figure
                data-testid={`testimonial-card-${i + 1}`}
                className="flex h-full flex-col border border-line bg-panel p-8 transition-colors duration-300 hover:border-gold/60"
              >
                <Quote size={22} className="text-gold" strokeWidth={1.5} />
                <div className="mt-4 flex gap-1" aria-label={`${r.rating} out of 5 stars`}>
                  {[1, 2, 3, 4, 5].map((n) => (
                    <Star
                      key={n}
                      size={15}
                      className={n <= r.rating ? "fill-gold text-gold" : "fill-zinc-800 text-zinc-800"}
                    />
                  ))}
                </div>
                <blockquote className="mt-4 flex-1 text-base leading-relaxed text-zinc-200">
                  “{r.quote}”
                </blockquote>
                <figcaption className="mt-6 border-t border-line pt-4">
                  <p className="font-cond text-lg font-bold uppercase tracking-[0.06em] text-zinc-50">
                    {r.customer_name}
                  </p>
                  {r.vehicle && (
                    <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-400">
                      {r.vehicle}
                    </p>
                  )}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
